import { FileService } from './../../services/file.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { ReportingService } from '../../services/reporting.service';
import { InvoiceReportModel } from '../../models/invoice-report.model';
import { Sort } from '@angular/material/sort';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { CommonService } from '../../services';
import { NgProgressService } from '../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';

declare var $: any;


@Component({
  selector: 'app-upcoming-microsoft-csp-renewals',
  templateUrl: './upcoming-microsoft-csp-renewals.component.html',
  styleUrls: ['./upcoming-microsoft-csp-renewals.component.css']
})
export class UpcomingMicrosoftCSPRenewalsComponent implements OnInit, OnDestroy {

  title = '';
  type = '';
  fromDate: NgbDate;
  toDate: NgbDate;
  strDateFrom = '';
  strDateTo = '';

  showPager = false;
  loadingFinished = false;
  loadContent = false;

  // subscriptionReports: InvoiceReportModel[] = [];
  // azureInvoiceReports: InvoiceReportModel[] = [];
  upcomingRenewals: any = [];
  sortedData: InvoiceReportModel[] = [];

  hasEmptyFilterResult: boolean = false;

  filterResultArr: any;

  //search
  searchField: string;

  //export excel
  url: string;

  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();
  

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private calendar: NgbCalendar,
    private reportingService: ReportingService,
    private commonService: CommonService,
    private fileService: FileService,
    private ngProgress: NgProgressService
  ) { 
    this.title = 'Upcoming Microsoft CSP Renewals';
  }

  dateFormat(date: any) {
    let day = parseInt(date.split('-')[0]);
    let month = parseInt(date.split('-')[1]) - 1;
    let year = parseInt(date.split('-')[2]);

    let formattedDate = new Date(year, month, day);
    return formattedDate.getTime();
  }
  
  sortData(sort: Sort) {
    let data = this.upcomingRenewals.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'tenantName': return compare(a.out_tenant_name.toLowerCase(), b.out_tenant_name.toLowerCase(), isAsc);
        case 'sku': return compare(a.out_stock_code.toLowerCase(), b.out_stock_code.toLowerCase(), isAsc);
        case 'description': return compare(a.out_stk_description.toLowerCase(), b.out_stk_description.toLowerCase(), isAsc);
        case 'qty': return compare(parseFloat(a.out_qty), parseFloat(b.out_qty), isAsc);
        case 'termStart': return compare(this.dateFormat(a.out_term_start_date.toLowerCase()), this.dateFormat(b.out_term_start_date.toLowerCase()), isAsc);
        case 'termExpiry': return compare(this.dateFormat(a.out_term_expiry_date), this.dateFormat(b.out_term_expiry_date.toLowerCase()), isAsc);
        default: return 0;
      }
    });
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(param => {
      this.ngProgress.start();
      // default the dates to start of the month and 90 days from that date 
      let today = new Date();
      this.fromDate = new NgbDate(today.getFullYear(), today.getMonth()+1, 1);
      let initEndDate = new Date(today.getFullYear(), today.getMonth(), 90);
      this.toDate = new NgbDate(initEndDate.getFullYear(), initEndDate.getMonth()+1, initEndDate.getDate());

      //initialize arrays
      this.upcomingRenewals = [];
      this.getUpcomingRenewals();
    });

   
  }

  getUpcomingRenewals() {
    this.ngProgress.start();
    const isValid = this.validateDayRanges('btnFilter');
    if (!isValid) return;
    this.convertDateFormat();
    this.reportingService.getUpcomingMicrosoftCSPRenewals(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((value: any) => {
      this.upcomingRenewals = value.output;
      this.sortedData = this.upcomingRenewals.slice();
      this.loadingFinished = true;
      this.loadContent = true;
    },
     (error: any) => {
      console.info(error),
      this.ngProgress.done();
     });
  }

  downloadReport():void {
    this.ngProgress.start();
    const isValid = this.validateDayRanges('btnFilter');
    if (!isValid) return;
    this.convertDateFormat();
    this.commonService.implementToast('Renewals report will be downloaded shortly', 'Info');
  
  
    this.reportingService.exportMSCSPRenewals(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data: any) => {
      const fileName = `UpcomingMicrosoftCSPRenewals.xlsx`;

      this.fileService.saveAsExcelFile(data, fileName);
      this.ngProgress.done();
      this.commonService.implementToast('Renewals report downloaded successfully', 'Success');
    },
    (error: any) => {
      console.info(error),
      this.ngProgress.done();
    });
  }

  filterRenewals(): void {
    const isValid = this.validateDayRanges('btnFilter');
    
    if(!isValid) return;

    this.loadContent = true;
    this.getUpcomingRenewals();

  }

  convertDateFormat(): void {
    this.strDateFrom = this.fromDate.day + '/' + this.fromDate.month + '/' + this.fromDate.year;
    this.strDateTo = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;
  }

  validateDayRanges(btnName: string):boolean {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utcFrom = Date.UTC(this.fromDate.year, this.fromDate.month, this.fromDate.day);
    const utcTo = Date.UTC(this.toDate.year, this.toDate.month, this.toDate.day);

    const days = Math.floor((utcTo - utcFrom) / _MS_PER_DAY);

    if (days > 90) {
      $('#' + btnName).showValidator('Report date range can be maximum of 90 days', 'error', 'right');
      return false;
    } else if (days < 1) {
      $('#' + btnName).showValidator('Invalid date range selected', 'error', 'right');
      return false;
    }

    return true;
  }

  onLoading(currentLoadingStatus: boolean) {
   
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  } 

  close() {
    //$('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/reporting');
  }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['out_tenant_name', 'out_stock_code', 'out_stk_description', 'out_qty', 'out_term_start_date', 'out_term_expiry_date'], this.searchField);

    if (this.filterResultArr.length === 0 && this.searchField !=='') {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  filterReset() {
    this.searchField = "";
    this.hasEmptyFilterResult = false;
  }

  // Add class 'expired-sub-date' to expiry dates that are past todays date 
  pastExpiry(expiry: string): boolean {
    let expDate = new Date (parseInt(expiry.split('-')[2]), parseInt(expiry.split('-')[1]) -1, parseInt(expiry.split('-')[0]));
    if (expDate < new Date) {
      return true;
    }
    return false;
  }

  showSubscription(renewal: any) {
    switch (renewal.out_stock_group){
      case '85RI':
        this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/' + renewal.out_tenant_guid + '?type=RI');
        break; 
      case '85SS':
        this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/' + renewal.out_tenant_guid + '?type=SS');
        break; 
      default:
        this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/' + renewal.out_tenant_guid + '/ManageLicenseSubscriotion/SubscriptionDetails;sub=' + renewal.out_subscription_guid);
    }
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

